<ng-container *ngIf="formGroup">
    <form [formGroup]="formGroup">
        <div class="text-type">
            <p class="title">
                {{ getParsedDescription(getText(question.globalizationConfig, "title")) }}

                <ng-container *ngIf="question.id === 884">
                    <ion-text [color]="'danger'">
                        {{ "managerEvaluation.bulletPoints" | translate }}
                    </ion-text>
                </ng-container>
                <span class="tooltip" *ngIf="getText(question.globalizationConfig, 'instructions')"
                      [matTooltip]="getText(question.globalizationConfig, 'instructions')">
                        ?
                    </span>
            </p>

            <ng-container *ngIf="showRequiredBadge(formGroup, question.currentIndex)">
                <p class="required">({{ "generic.obligatoryField" | translate }})</p>
            </ng-container>

            <ion-textarea autoGrow="true"
                    *ngIf="!formGroup.get('field' + question.currentIndex + (isManagerComment ? 'Comment' : ''))?.disabled"
                    [formControlName]="'field' + question.currentIndex + (isManagerComment ? 'Comment' : '')"
                    [placeholder]="getText(question.globalizationConfig, 'placeholder')"
                    [maxlength]="question.typeConfig?.max && question.typeConfig.max > 0 ? question.typeConfig.max : 1000000"
            >
            </ion-textarea>

            <p
                    class="charCount"
                    [ngClass]="{
                        limitReached: formGroup.get('field' + question.currentIndex + (isManagerComment ? 'Comment' : '')).value?.length === question.typeConfig?.max
                    }"
                    *ngIf="!formGroup.get('field' + question.currentIndex + (isManagerComment ? 'Comment' : ''))?.disabled && question.typeConfig?.max > 0"
            >
                {{ formGroup.get("field" + question.currentIndex).value?.length || 0 }}
                /{{ question.typeConfig?.max }}
            </p>

            <div *ngIf="question.showPreview" style="margin: 0px 10px 10px 10px">
                {{ "generic.preview" | translate }} :
                <hr/>
                <li *ngFor="let answer of separateAnswers(formGroup.get('field' + question.currentIndex + (isManagerComment ? 'Comment' : '')).value)">
                    {{ answer }}
                </li>
            </div>

            <p *ngIf="formGroup.get('field' + question.currentIndex + (isManagerComment ? 'Comment' : ''))?.disabled"
               style="white-space: pre-wrap">
                {{ formGroup.get("field" + question.currentIndex + (isManagerComment ? "Comment" : "")).value }}
            </p>

            <app-question-answer
                    *ngIf="evaluation && getQuestionAnswer(question)"
                    style="width: 100%"
                    [question]="question"
                    [evaluation]="evaluation"
                    [managerAnswer]="managerAnswer"
                    [answer]="getQuestionAnswer(question)"
            ></app-question-answer>
        </div>
    </form>
</ng-container>